export default __webpack_public_path__ + "assets/webgl/scene-2.3bf1318b.glb";